<template>
  <!-- 生成人群弹窗 -->
  <div class="bigbox">
    <jd-dialog
      :visible.sync="isShowCrowdDialog"
      title="生成人群包"
      width="630px"
      :before-close="close"
    >
      <jd-tip class="mb16">
        <div>
          <p>1.京东人群营销场景：短信、富信、卡片短信及咚咚专享客户触达；</p>
          <p>
            2.云起人群营销场景：用于批量发放权益中快捷选择人群、互动活动中指定人群等场景。如需进行短信、富信、卡片短信及咚咚专享客户触达需先进行转化为京东人群。
          </p>
        </div></jd-tip
      >
      <el-form
        :model="crowdForm"
        label-width="124px"
        class="demo-ruleForm new-input-box"
      >
        <el-form-item label="人群名称" prop="name" required>
          <el-input
            class="pdr"
            v-model="crowdForm.name"
            placeholder="请输入"
            maxlength="50"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="人群描述" prop="description" required>
          <el-input
            class="pdr"
            v-model="crowdForm.description"
            placeholder="请输入"
            maxlength="50"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="生成人群类型：" prop="description" required>
          <!-- <el-checkbox-group v-model="crowdType"> -->
          <el-checkbox v-model="crowdForm.isBuildJdCrowd"
            >生成京东人群</el-checkbox
          >
          <el-checkbox v-if="newplatformFlag" v-model="crowdForm.isBuildHdCrowd"
            >生成云起人群</el-checkbox
          >
          <!-- </el-checkbox-group> -->
        </el-form-item>
      </el-form>

      <div slot="footer">
        <!-- <el-button type="primary" style="width:auto" @click='save(1)' v-loading='btnLoading'>生成人群并去营销</el-button> -->
        <jd-button type="blue" @click="save(2)" v-loading="btnLoading"
          >确认生成</jd-button
        >
        <jd-button
          style="margin-right: 12px"
          @click="$emit('update:isShowCrowdDialog', false)"
          >取消</jd-button
        >
      </div>
    </jd-dialog>
  </div>
</template>

<script>
import tipBox from "@/components/new/tip-box";
import { addCrowd } from "@/api/tbOrder";
import { yunQiCrowdAdd } from "@/api/manage/memberCrowdController";
import { mapState, mapMutations } from "vuex";
export default {
  name: "crowd-dialog",
  props: {
    isShowCrowdDialog: {
      type: Boolean,
      default: false,
    },
    // 生成条件
    condition: {
      type: Object,
      default: {},
    },
    // 来源  1手动导入 2客户标签生成 3权益发放生成 4 订单生成 5营销画布生成 6 京东人群转化 7互动生成 8数据中心（数据分析）生成 9京获客生成
    source: {
      type: Number,
      default: 0,
    },
    // 输入框的默认值
    defaultValue: {
      type: Boolean,
      default: false,
    },
    defaultValueText: {
      type: String,
      default: "",
    },
    isShowCreateText: {
      type: Boolean,
      default: true,
    },
    // 根据newplatformFlag判断替换旧版接口
    isReplaceInterface: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    tipBox,
  },
  data() {
    return {
      crowdForm: {
        name: "",
        description: "",
        isBuildJdCrowd: false,
        isBuildHdCrowd: false,
      },
      crowdType: [],
      btnLoading: false,
    };
  },
  created() {
    if (this.defaultValue) {
      let createText = "创建";
      if (this.isShowCreateText == false) {
        createText = "";
      }
      this.crowdForm.name =
        this.defaultValueText + createText + this.getFormatDate();
      this.crowdForm.description =
        this.defaultValueText + createText + this.getFormatDate();
    }
  },
  methods: {
    save(type) {
      if (!this.crowdForm.name) {
        return this.$message.warning("请输入人群名称");
      } else if (!this.crowdForm.description) {
        return this.$message.warning("请输入人群描述");
      }
      if (!this.crowdForm.isBuildJdCrowd && !this.crowdForm.isBuildHdCrowd)
        return this.$message.warning("请选择生成人群类型！");
      this.btnLoading = true;
      // if(this.crowdType.includes(0)){
      //   addCrowd(obj).then(res=>{
      //     this.btnLoading = false
      //     if(res.code == 1) {
      //       this.$message.success(res.message)
      //       this.$emit('update:isShowCrowdDialog',false)
      //       if(type == 1) {
      //         this.$router.push({name:'accurate_market'})
      //       }
      //     }else{
      //       this.$message.error(res.message)
      //     }
      //   }).catch(err=>{
      //     this.btnLoading = false
      //   })
      // }
      // if(this.crowdType.includes(1)){
      let param = {
        source: this.source,
        ...this.crowdForm,
        condition: JSON.stringify(this.condition),
      };
      // let param1 = {
      //   source: this.source,
      //   ...this.crowdForm,
      //   ...this.condition,
      // };
      let reqFn = null;
      let paramsCom = null;
      if (this.isReplaceInterface) {
        if (this.newplatformFlag) {
          paramsCom = param;
          reqFn = yunQiCrowdAdd;
        } else {
          paramsCom = param;
          reqFn = yunQiCrowdAdd;
        }
      } else {
        paramsCom = param;
        param.condition = JSON.stringify(this.condition);
        reqFn = yunQiCrowdAdd;
      }
      reqFn(paramsCom)
        .then((res) => {
          this.btnLoading = false;
          if (res.code == 1) {
            this.$message.success(res.message);
            this.$emit("update:isShowCrowdDialog", false);
            if (type == 1) {
              this.$router.push({ name: "accurate_market" });
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.btnLoading = false;
        });
      // }
    },
    close() {
      this.$emit("update:isShowCrowdDialog", false);
    },
    getFormatDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      let currentDate =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds;
      return currentDate;
    },
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    newplatformFlag() {
      return this.$store.getters.loginUserInfo.platformFlag;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__error {
  display: none;
}

::v-deep .pdr .el-input__inner {
  padding-right: 50px;
}
</style>
